import React from 'react';

// To use this component, you would need to include the Bootstrap CDN in your main index.html file.
// <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">

const NotFoundPage = () => {
  // Inline styles for custom styling beyond Bootstrap
  const styles = {
    pageContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      backgroundColor: '#f8f9fa',
      fontFamily: '"Inter", sans-serif',
    },
    card: {
     
      padding: '2rem 3rem',
      borderRadius: '15px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      border: 'none',
    },
    header404: {
      fontSize: '8rem',
      fontWeight: 'bold',
      color: '#0d6efd',
      lineHeight: '1',
      marginBottom: '0',
    },
    subheading: {
      fontSize: '2rem',
      fontWeight: '600',
      color: '#343a40',
    },
    message: {
      color: '#6c757d',
      fontSize: '1.1rem',
    },
    homeButton: {
      borderRadius: '50px',
      padding: '12px 30px',
      fontSize: '1rem',
      fontWeight: '600',
      transition: 'all 0.3s ease',
    },
    illustration: {
      maxWidth: '200px',
      height: 'auto'
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div className="container text-center">
        <div className="card" style={styles.card}>
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-12">
                 {/* Simple SVG illustration for a lost connection */}
                 <svg style={styles.illustration} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50,2.5 C23.8,2.5 2.5,23.8 2.5,50 C2.5,76.2 23.8,97.5 50,97.5 C76.2,97.5 97.5,76.2 97.5,50 C97.5,23.8 76.2,2.5 50,2.5 Z M50,92.5 C26.6,92.5 7.5,73.4 7.5,50 C7.5,26.6 26.6,7.5 50,7.5 C73.4,7.5 92.5,26.6 92.5,50 C92.5,73.4 73.4,92.5 50,92.5 Z" fill="#6c757d" opacity="0.3"/>
                    <path d="M62.5,35.5 C61.1,35.5 60,36.6 60,38 L60,45 L40,45 L40,38 C40,36.6 38.9,35.5 37.5,35.5 C36.1,35.5 35,36.6 35,38 L35,47.5 C35,48.9 36.1,50 37.5,50 L62.5,50 C63.9,50 65,48.9 65,47.5 L65,38 C65,36.6 63.9,35.5 62.5,35.5 Z" fill="#0d6efd"/>
                    <circle cx="35" cy="62" r="5" fill="#0d6efd"/>
                    <circle cx="65" cy="62" r="5" fill="#0d6efd"/>
                    <path d="M42,75 C43.8,70.5 48.7,68 50,68 C51.3,68 56.2,70.5 58,75" fill="none" stroke="#0d6efd" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <div className="col-md-12">
                <h1 style={styles.header404}>404</h1>
                <p style={styles.subheading}>Page Not Found</p>
              </div>
            </div>
            <div className="mt-4">
              <p style={styles.message}>
                Sorry, the page you are looking for does not exist. It might have been moved, renamed, or is temporarily unavailable.
              </p>
              <a href="/" className="btn btn-primary" style={styles.homeButton}>
                Go to Homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// To render this component, you would typically have a root component like App
// which then gets rendered to the DOM.
// For example: export default NotFoundPage;
// And in your App.js: import NotFoundPage from './NotFoundPage';
// This file assumes it's the main component to be displayed.
export default NotFoundPage;
